import { Link } from 'react-router-dom';

const ResidentialServices = () => {
  const services = [
    {
      icon: 'ri-dashboard-line',
      title: 'Switchboard Upgrades',
      description: 'Modern switchboard installations and upgrades to improve safety and electrical capacity for your home. We replace outdated fuse boxes with compliant circuit breaker systems.',
      image: 'https://public.readdy.ai/ai/img_res/347801c2f96d22ca1915988ffd429905.jpg',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Lighting Installations',
      description: 'Indoor and outdoor lighting solutions including LED upgrades, downlights, feature lighting and garden illumination. Energy-efficient options that enhance your home.',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20home%20interior%20with%20LED%20downlights%20and%20contemporary%20lighting%20fixtures%20in%20living%20room%20showing%20professional%20residential%20electrical%20installation%20with%20warm%20ambient%20lighting%20and%20clean%20design&width=600&height=450&seq=res-lighting&orientation=landscape',
    },
    {
      icon: 'ri-plug-line',
      title: 'Power Point Installations',
      description: 'Additional power points, USB charging outlets and dedicated circuits for appliances. We ensure convenient power access throughout your home.',
      image: 'https://public.readdy.ai/ai/img_res/edited_1edfb659924ce981a6e45249a0f151cc_e6223624.jpg',
    },
    {
      icon: 'ri-tools-line',
      title: 'Fault Finding &amp; Repairs',
      description: 'Expert troubleshooting and repair services for electrical issues. We quickly identify and fix problems to restore safe operation in your home.',
      image: 'https://readdy.ai/api/search-image?query=professional%20electrician%20using%20testing%20equipment%20and%20multimeter%20to%20diagnose%20residential%20electrical%20fault%20in%20australian%20home%20showing%20expert%20problem%20solving%20and%20technical%20service%20with%20clean%20background&width=600&height=450&seq=res-faultfinding&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'RCD Safety Upgrades',
      description: 'Installation of safety switches (RCDs) to protect your family from electrical hazards. Essential safety devices that can save lives.',
      image: 'https://readdy.ai/api/search-image?query=residential%20electrical%20safety%20switch%20RCD%20device%20installation%20in%20modern%20australian%20home%20switchboard%20showing%20professional%20safety%20upgrade%20work%20and%20compliance%20with%20clean%20organized%20wiring&width=600&height=450&seq=res-rcd&orientation=landscape',
    },
    {
      icon: 'ri-home-gear-line',
      title: 'Renovation &amp; Extension Wiring',
      description: 'Complete electrical installations for home renovations, extensions and new builds. We work with your builder to deliver quality results.',
      image: 'https://public.readdy.ai/ai/img_res/edited_076267796171c8824f46effd03b01e11_7e7cd4ef.jpg',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-navy mb-4">Our Residential Services</h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-6"></div>
          <p className="text-charcoal text-lg max-w-3xl mx-auto">
            Professional electrical solutions for homeowners across Western Australia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:border-gold transition-all hover:shadow-lg"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-gold text-5xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">{service.title}</h3>
                <p className="text-charcoal text-base leading-relaxed mb-6">
                  {service.description}
                </p>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-navy font-semibold text-sm hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
                >
                  Get a Quote
                  <i className="ri-arrow-right-line text-lg w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResidentialServices;